module.exports = __webpack_public_path__ + "static/img/pbx_board.1456267.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pbx_board.jpeg
// module id = V/RF
// module chunks = 0